import { useTraces } from './api';

export const TRACE_ENTITY = {
  appLogic: useTraces,
};
